import { colors, darkColors } from './colors.js';
import { layout } from './layout.js';
import { transitions } from './transitions.js';
import { typography } from './typography.js';
import { misc } from './misc.js';

const baseTheme = {
  name: 'base',
  mode: 'light',
  colors,
  ...layout,
  ...transitions,
  ...typography,
  ...misc
};
const baseDarkTheme = {
  ...baseTheme,
  mode: 'dark',
  colors: darkColors
};

export { baseDarkTheme, baseTheme };
